var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{attrs:{"id":"map","center":_vm.center,"zoom":13,"options":_vm.options,"map-type-id":"terrain"}},[_c('gmap-marker',{attrs:{"position":_vm.center}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }